/* eslint-disable no-restricted-imports */
import { Add } from './validate/add';
import { Divide } from './validate/div';
import { Mod } from './validate/mod';
import { Multiply } from './validate/mul';
import { MultiplyAndDivide } from './validate/mulAndDiv';
import { Subtract } from './validate/sub';
var getters = {
    Add: Add,
    Subtract: Subtract,
    Multiply: Multiply,
    Divide: Divide,
    MultiplyAndDivide: MultiplyAndDivide,
    Mod: Mod,
};
export var TokensMath = {
    getters: getters,
};
